module.exports = __webpack_public_path__ + "a4b915c3ff3f01c25646c659b068f5cd.pdf";